/* eslint-disable id-denylist */
import { generateVaultApiUrl, createAxiosInstance } from 'utils/Api';
import { VaultAnswerClassificationSubTopicBreakdownResponse } from 'screens/WidgetGenerator/utils/answerClassificationBreakdown';

export const DEFAULT_DEPTH_LEVEL_TO_GROUP_BY = 1;

const apiUrl = generateVaultApiUrl('/api/v2/answers_classification_sub_topics_breakdown/');
const axiosInstance = createAxiosInstance(apiUrl);

export const getAnswerClassificationSubTopicBreakdown = async (
  zcClientId: string,
  params: {
    survey_group: number;
    generic_question?: number;
    start_date?: string;
    end_date?: string;
    division?: number[];
    group_by_depth_level?: string;
  },
): Promise<VaultAnswerClassificationSubTopicBreakdownResponse> => {
  const {
    division,
    group_by_depth_level: groupByDepthLevel = DEFAULT_DEPTH_LEVEL_TO_GROUP_BY,
    ...restOfParams
  } = params;
  const response = await axiosInstance.get<VaultAnswerClassificationSubTopicBreakdownResponse>('', {
    params: {
      ...restOfParams,
      group_by_depth_level: groupByDepthLevel,
      division: division && division.length > 0 ? division.join(',') : undefined,
    },
    headers: {
      'X-Zc-Client-Id': zcClientId,
    },
  });

  return response.data;
};
